import BasePath from "./BasePath";

export default {
    initPasswordRenewal: new BasePath("client/v5/external/passwords/renewal"),
    getAvailableFactors: new BasePath("client/v5/external/authorizations"),
    authorizationsKeys: new BasePath("client/v5/external/authorizations/keys"),
    setPassword: new BasePath("client/v5/external/passwords")
};
